import request from '@/utils/request'

/**
 * 获取网站访问日志列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回请求的Promise对象
 */
export function listWebsiteAccessLog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/websiteAccessLog.listWebsiteAccessLog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}